import { withFormik } from "formik";
import * as Yup from "yup";

const formikEnhancer = withFormik({
  validationSchema: Yup.object().shape({
    service_id: Yup.string()
      .trim()
      .required("This field is required"),
    rd_id: Yup.string()
      .trim()
      .required("This field is required"),
    rd_type: Yup.string().trim(),
    report_type: Yup.string()
      .trim()
      .required("This field is required"),
    upload_file: Yup.mixed()
      .required("File is required")
      .test("type", "Only .xls or .xlsx file format is accepted", value => {
        return (
          value &&
          (value.type === "application/vnd.ms-excel" ||
            value.type ===
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
        );
      })
  }),
  mapPropsToValues: props => ({
    service_id: "",
    rd_id: "",
    upload_file: "",
    rd_type: "",
    report_type: ""
  }),
  handleSubmit: values => {},
  displayName: "CustomValidationForm",
  enableReinitialize: true
});

export default formikEnhancer;
